export default __webpack_public_path__ + "static/media/wilfred-close.5871fa7c.jpg";